/* eslint-disable no-unused-vars */
import ApiClient from '../ApiClient';
import { NiceResponse } from '../dto/NiceResponse';
import AxlStageTypes from './dto/AxlStageTypes';
import CreateStageTypestReq from './dto/CreateStageTypestReq';
import StageTypes from './dto/StageTypes';

export class StageTypesApi {
  constructor(private api: ApiClient) {}

  path = '/stage-types';

  async create(req: CreateStageTypestReq) {
    const resp = await this.api.client.post<NiceResponse<string>>(this.path, {
      ...req,
    });
    return resp.data;
  }

  async update(id: string, req: CreateStageTypestReq) {
    const resp = await this.api.client.put<NiceResponse<string>>(
      `${this.path}/${id}`,
      {
        ...req,
      },
    );
    return resp.data;
  }

  async delete(id: string) {
    const resp = await this.api.client.delete<NiceResponse<string>>(
      `${this.path}/${id}`,
    );
    return resp.data;
  }

  async getAll(skip = 0, take = 250) {
    const resp = await this.api.client.get<NiceResponse<StageTypes[]>>(
      this.path,
      {
        params: {
          skip,
          take,
        },
      },
    );
    return resp.data;
  }

  async getAxlStages() {
    const resp = await this.api.client.get<NiceResponse<AxlStageTypes[]>>(
      `${this.path}/axl-stages`,
    );
    return resp.data;
  }
}
